import { useState } from 'react'
import moment from 'moment'
import { Button, Error, SEO, Title } from 'components/common'
import { BookingStatusTable, DayStatusCard } from 'components/bookings'
import { useBookingStatusOfTheDayQuery } from 'lib/graphql/storeadmin'

export const Anchor = (): JSX.Element => (
  <Button>
    <a href="/admin" target="_blank" rel="noopener noreferrer">
      時間帯毎の予約状況を確認する
    </a>
  </Button>
)

export const Head = () => <SEO title="予約状況" />

const Index = (): JSX.Element => {
  const [viewDay, setViewDay] = useState<moment.Moment>(moment())
  const { data, loading, error, refetch } = useBookingStatusOfTheDayQuery({
    variables: { input: { date: viewDay.format('YYYY-MM-DD') } },
  })

  const handleViewDay = (date: moment.Moment) => {
    setViewDay(date)
    refetch()
  }

  if (error) {
    return Error.render(error)
  }

  return (
    <>
      <Title>予約状況</Title>
      <DayStatusCard viewDay={viewDay} handleDailyView={handleViewDay}>
        <BookingStatusTable data={data} loading={loading} />
      </DayStatusCard>
    </>
  )
}

export default Index
